<script>

  import {API_VILLAGE, API_COMPANY} from '../../common/api'
  import {rangeVillage, getFirstNode} from '../../assets/js/funcs'
  import CompanyUpdate from '../company/CompanyUpdate'
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";

  export default {
    components: {ElButton},
    name: 'Home',
    data() {
      return {
        loading: false,
        companyObj: null,
        company_id: this.$store.state.home.user_obj.company_id,
        role_id: this.$store.state.home.user_obj.role_id,
        updateDialogVisible: false
      }
    },
    created() {
      // 获取公司信息
      this.getCompany();
      // 在系统首页请求小区列表，用户加载小区下拉列表框数据
      this.getVillageList();
    },
    methods: {
      getVillageList() {
        if (this.$store.state.village.villageList && this.$store.state.village.villageList.length > 0) {
          // console.log('已经存在小区数据，不用重新请求');
          return
        }
        let params = {
          page_no: 1,
          page_num: 1000
        };
        this.$http.GET(API_VILLAGE, params,
          res => {
            this.$store.commit('setVillage', res.result.list);
            this.$store.commit('setArrangeVillage', rangeVillage(res.result.list))
          }, err => {
            console.log(err)
          })
      },
      // 获取公司信息
      getCompany() {
        this.$http.GET(API_COMPANY + '/' + this.company_id, null,
          res => {
            this.companyObj = res.result.data;
          }, err => {
            this.$message.error(err.msg);
          }
        );
      },
      updateCompanySuccess () {
        this.updateDialogVisible = false;
        this.getCompany()
      }
    },
    components: {
      CompanyUpdate
    }
  }

</script>

<template>
  <div class="main">
    <div class="company_title">
      <div>公司信息</div>
      <div>
        <el-button v-if="role_id == 1 || role_id == 2" type="primary" @click="updateDialogVisible = true">修改</el-button>
      </div>
    </div>
    <div class="company_content">
      <div class="company_item">名称：{{ companyObj ? companyObj.name : '' }}</div>
      <div class="company_item">地址：{{ companyObj ? companyObj.address : '' }}</div>
      <div class="company_item">电话：{{ companyObj ? companyObj.phone : '' }}</div>
      <div class="company_item">手机号：{{ companyObj ? companyObj.admin_mobile : '' }}</div>
      <div class="company_item">负责人：{{ companyObj ? companyObj.admin_name : '' }}</div>
      <div class="company_item">水费单价：{{ companyObj ? companyObj.price : '' }}元/吨</div>
      <div class="company_item">水资源税：{{ companyObj ? companyObj.tax: '' }}元/吨</div>
    </div>


    <el-dialog
      title="修改公司"
      v-if="updateDialogVisible"
      :visible.sync="updateDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <CompanyUpdate :company_id="this.company_id" @updateCompanySuccess="updateCompanySuccess"></CompanyUpdate>
    </el-dialog>
  </div>

</template>

<style lang="scss" scoped>
  @import '../../assets/styles/variable';
  @import '../../assets/styles/table.scss';

  .main {
    padding: 10px;

    background-color: white;

    .company_title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      color: $siderbarBackgroundColor;
      font-size: 20px;
    }

    .company_content {
      /*background-color: #F3F3F3;*/
      border-top: 1px solid rgb(229, 229, 229);
      margin-top: 10px;
      padding: 5px 10px 10px 10px;
      .company_item {
        font-size: 14px;
        margin-top: 10px;
        color: $blackTextColor;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/home/Home.vue